import React, {useContext} from "react";
import PropTypes from "prop-types";

import {generateClassString as gcs} from "../../../../../lib/helper/generateClassString";
import CameraFilterContext from "../../../CameraListing/CameraFilterContext";
import t from "../../../../../lib/translate";
import * as styles from "./check.module.less";

function Check({filterKey, settings = {}, options = []}) {
    const {addFilterOptionAction, removeFilterOptionAction} =
        useContext(CameraFilterContext);

    const {labelTranslation} = settings;

    if (!options.length) return null;

    return (
        <div className={styles.checkWrapper}>
            <span>{`${labelTranslation ? t(labelTranslation) : filterKey}`}</span>
            <div>
                {options.map(
                    ({value, label, active = false, disabled = false}) => (
                        <label className={gcs([!active && disabled, styles.disabled])}>
                            <input type="checkbox"
                                   key={value}
                                   checked={active}
                                   disabled={!active && disabled}
                                   onChange={() =>
                                       active || disabled
                                           ? removeFilterOptionAction(filterKey, value)
                                           : addFilterOptionAction(filterKey, value)
                                   }
                            />
                            {`${label}`}
                        </label>

                    )
                )}
            </div>
        </div>
    );
}

Check.defaultProps = {
    settings: {}
};

Check.propTypes = {
    filterKey: PropTypes.string.isRequired,
    settings: PropTypes.shape({
        labelTranslation: PropTypes.string
    }),
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
            active: PropTypes.bool,
            disabled: PropTypes.bool
        })
    )
};

export {Check};
